import axios from "axios";
import axiosInstance from "../axios/axiosInstance";


axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        const userRole = localStorage.getItem('userRole');
        if (userRole === 'admin') {
            config.headers['X-Role'] = 'admin';
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                if (!refreshToken) {
                    throw new Error("Refresh token not available.");
                }

                const response = await axiosInstance.post('/refresh', { token: refreshToken });
                const newToken = response.data.token;

                localStorage.setItem('token', newToken);
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

                return axiosInstance(originalRequest);
            } catch (err) {
                logout();
                window.location.href = '/login';
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);


const login = async (login, password) => {
    try {
        const response = await axiosInstance.post("/login", { login, password });

        if (response.data.success) {
            const userData = response.data.data;
            localStorage.setItem('token', userData.token);
            localStorage.setItem('refreshToken', userData.refreshToken);
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('userRole', userData.role[0]);
            return { success: true };
        } else {
            console.error("Ошибка входа:", response.data.message);
            return { success: false, message: response.data.message };
        }
    } catch (error) {
        console.error("Ошибка сервера:", error);
        return { success: false, message: "Ошибка сервера" };
    }
};

// Функция для получения роли пользователя
const getUserRole = async () => {
    try {
        const userRole = localStorage.getItem('userRole');
        return userRole;
    } catch (error) {
        console.error("Ошибка при получении роли пользователя:", error);
        return null;
    }
};


const getUsername = async () => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            return null;
        }
        return user.name;
    } catch (error) {
        console.error("Ошибка при получении имени пользователя:", error);
        return null;
    }
};


const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userRole');
    window.location.href = '/login';
};


const isLoggedIn = () => {
    return !!localStorage.getItem('token');
};

export { login, logout, isLoggedIn, getUserRole, getUsername, getStoredRoles, hasRole };

function getStoredRoles() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        const list = user?.role ?? user?.roles;
        if (Array.isArray(list) && list.length) return list;
    } catch {
        /* ignore */
    }
    const single = localStorage.getItem('userRole');
    return single ? [single] : [];
}

function hasRole(role) {
    return getStoredRoles().includes(role);
}
